// extracted by mini-css-extract-plugin
module.exports = {"scorecardTable":"style_scorecardTable__xCjSK","batterName":"style_batterName___kCZZ","subText":"style_subText__elZ34"};